export const FULL_PAGE_CAROUSEL_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'full-page-carousel-layout',
  LAYOUT_LABEL: 'Full Page Carousel',
  LAYOUT_IMAGE_PATH: 'https://cdn-www.topfans.com/TopFans/1786001737567.png',
  LAYOUT_DESCRIPTION:
    'Full-page carousel with background images, headline, subheading, CTA, navigation arrows and pagination dots',
  MAX_SCAN_SLIDES: 50,
  SLIDE_TRANSITION_MS: 600,
  BACKGROUND_IMAGE_WIDTH_PX: 1280,
  BACKGROUND_IMAGE_HEIGHT_PX: 675,
  MOBILE_BACKGROUND_IMAGE_WIDTH_PX: 390,
  MOBILE_BACKGROUND_IMAGE_HEIGHT_PX: 700,
  DEFAULT_ALT_BACKGROUND_IMAGE: 'Full page carousel background',
  NAV_PREV_ARIA_LABEL: 'Previous slide',
  NAV_NEXT_ARIA_LABEL: 'Next slide',
  PLACEHOLDER_IMAGE_LABEL: 'Background Image',
  BANNER_IMAGE_TITLE: 'Add Image',
  BANNER_IMAGE_LABEL: 'SELECT FILE',
  SLIDE_LINK_ARIA_LABEL: 'Open linked content',
  CAROUSEL_LINK_FIELD: 'carousel_link',
  CAROUSEL_LINK_PORTFOLIO_PREFIX: 'PORTFOLIO',
  CAROUSEL_LINK_PORTFOLIO_COLLECTION_PREFIX: 'ALBUM',
  FEED_POST_ROUTE_PREFIX: '/post',
  FEED_POST_SK_SEPARATOR: '#',
  FEED_POST_USER_KEY_PREFIX: 'USER',
  FEED_POST_QUERY_TYPE: 'profile',
  FEED_POST_QUERY_PARAM: 'type'
} as const;

export const FULL_PAGE_CAROUSEL_SLIDE_FIELD_PREFIX = 'full_page_carousel_slide_';

export const FULL_PAGE_CAROUSEL_SLIDE_FIELD_SUFFIXES = [
  'background_image',
  'background_image_mobile',
  'section_heading',
  'subheading',
  'carousel_link',
  'cta_text',
  'cta_link'
] as const;

export function getFullPageCarouselSlideFieldName(slideIndex: number, suffix: string): string {
  return `${FULL_PAGE_CAROUSEL_SLIDE_FIELD_PREFIX}${slideIndex}_${suffix}`;
}

export function hasFullPageCarouselSlideFieldValue(value: unknown): boolean {
  if (value == null) {
    return false;
  }
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  return true;
}

export function getFullPageCarouselSlideCount(data: Record<string, unknown>): number {
  let count = 0;
  for (let i = 1; i <= FULL_PAGE_CAROUSEL_LAYOUT_CONSTANTS.MAX_SCAN_SLIDES; i++) {
    const hasContent = FULL_PAGE_CAROUSEL_SLIDE_FIELD_SUFFIXES.some((suffix) =>
      hasFullPageCarouselSlideFieldValue(data[getFullPageCarouselSlideFieldName(i, suffix)])
    );
    if (hasContent) {
      count = i;
    } else if (count > 0) {
      break;
    }
  }
  return Math.max(1, count);
}
